import { ENROLLMENT_STATUS } from "@/constants";
import { KLAYO_COLORS } from "@/themes";


export const getEnrollmentStatusColor = (status: string) => {
  switch (status) {
    case ENROLLMENT_STATUS.IN_PROGRESS:
      return KLAYO_COLORS.NeonBlueNB400;
    case ENROLLMENT_STATUS.FAILED:
      return KLAYO_COLORS.TouchRedTR600;
    case ENROLLMENT_STATUS.PENDING_REVIEW:
      return KLAYO_COLORS.GoldGD800;
    case ENROLLMENT_STATUS.COMPLETED:
    case ENROLLMENT_STATUS.PASSED:
      return KLAYO_COLORS.LimeGreenLG700;
    default:
      return KLAYO_COLORS.GreyGR400;
  }
};